import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import Whitespace from "components/ProjectNonSpecificComponents/Elements/Whitespace"
import parseValueForType from "components/ProjectNonSpecificComponents/Functions/parseValueForType"
import { IToolAttachmentMetadata } from "components/ProjectSpecificComponents/Interfaces/DataInterface"
import { ISavedRequestFormField } from "components/ProjectSpecificComponents/Interfaces/FormsInterface"
import i18n from "i18n"
import React, { Fragment, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import styled from "styled-components"
import SepLine from "../../Global/atoms/SepLine"
import AddedAttachmentsRepr from "../../Global/molecules/AddedAttachmentsRepr"

interface Props {
	config: ISavedRequestFormField[] | undefined
	addedAttachmentsData: IToolAttachmentMetadata[] | undefined
}

const SavedRequestFormDescSection = ({ config, addedAttachmentsData }: Props) => {
	const { t } = useTranslation()
	// ! TECHNICAL DEBT: 3184, replace this with dynamic key ([parsedkey])
	const isEN = i18n.language === "en"
	// Extra state to prevent caching on reopening
	const [configuration, setConfiguration] = useState<ISavedRequestFormField[]>()

	useEffect(() => {
		config && setConfiguration([...config])
		return () => {
			// Clean up
			setConfiguration(undefined)
		}
	}, [config])

	return (
		<Section className="flex-col">
			<div style={{ overflowY: "auto" }}>
				{configuration &&
					configuration.map(
						({ nameEN, nameLV, mainFieldKey, mainFieldLabel, value, fieldType, color }, i) => {
							const isFieldSingleRow = fieldType != "RICHTEXT"
							const valueFromType = parseValueForType(value, fieldType)
							return (
								<div key={configuration[i].mainFieldKey}>
									{isFieldSingleRow ? (
										<HyperDiv direction="row">
											<HyperDiv
												className="font-weight-bold text-transform-uppercase"
												flex="2"
												wraps
											>
												{isEN
													? nameEN ?? t("rawText.unspecified", { lng: "en" }).toUpperCase()
													: nameLV ?? t("rawText.unspecified", { lng: "lv" }).toUpperCase()}
											</HyperDiv>
											<Whitespace x="0.2" h />
											<HyperDiv flex="2">
												<HyperDiv
													width="fit-content"
													style={{
														backgroundColor: color ? `#${color}` : undefined,
														borderRadius: "5px",
														maxWidth: "100%",
													}}
												>
													{valueFromType ?? TEST_VALUE}
												</HyperDiv>
											</HyperDiv>
										</HyperDiv>
									) : (
										<HyperDiv direction="column">
											<HyperDiv className="font-weight-bold text-transform-uppercase" wraps>
												{isEN
													? nameEN ?? t("rawText.unspecified", { lng: "en" }).toUpperCase()
													: nameLV ?? t("rawText.unspecified", { lng: "lv" }).toUpperCase()}
											</HyperDiv>
											<Whitespace x="1" />
											<HyperDiv>{value ?? TEST_VALUE}</HyperDiv>
										</HyperDiv>
									)}
									{i != configuration.length - 1 && (
										<>
											<Whitespace x="1" />
											<SepLine />
											<Whitespace x="1" />
										</>
									)}
								</div>
							)
						}
					)}

				{addedAttachmentsData && addedAttachmentsData.length > 0 && (
					<AddedAttachmentsRepr data={addedAttachmentsData} />
				)}
			</div>
		</Section>
	)
}

export default SavedRequestFormDescSection

const Section = styled.div`
	padding: 1rem;
	min-width: 350px;
`

const TEST_VALUE =
	"This is a test value. This value will come from the request's author when the request is created."
